import { Outlet, useNavigate } from "react-router-dom";
import { Suspense, useEffect } from "react";
import LogoLoader from "../common/components/Loaders/LogoLoader";
import Navbar from "../common/components/Navbar/Navbar";
import ClarityProvider from "../providers/ClarityProvider";

const CustomerLayout = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const loginMode = localStorage.getItem("loginMode");
    const token = localStorage.getItem("token");

  }, []);

  return (
    <>
      <ClarityProvider />
      <div className="flex h-dvh max-h-dvh min-h-0 flex-col overflow-hidden">
        <header className="shrink-0">
          <Navbar />
        </header>
        <main
          id="layout"
          className="flex min-h-0 flex-1 flex-col overflow-y-auto overflow-x-hidden"
        >
          <Suspense fallback={<LogoLoader />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </>
  );
};

export default CustomerLayout;
